import {useNavigate} from "react-router-dom";
import {API_URL} from "../../URL";
import {Header} from "../../components/Header/Header";
import {WorkSpace} from "../../components/WorkSpace/WorkSpace";
import {useDispatch, useSelector} from "react-redux";
import {SET_USER} from "../../store/constants";

export default function Cabinet() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const navigate = useNavigate();

    const logout = async () => {
        await fetch(API_URL + "/logout", {
            method: "POST",
            credentials: "include",
        });

        dispatch({type: SET_USER, payload: true})
        navigate("/login");
    };

    return (
        <main>
            <WorkSpace user={user}/>
        </main>
    );
}